// extracted by mini-css-extract-plugin
module.exports = {"container":"PieChart_container__25Frj","title":"PieChart_title__mAZAe","block":"PieChart_block__3vl-s","rightBlock":"PieChart_rightBlock__1oa1B","info":"PieChart_info__2CHsF"};